import { useState, useEffect, useMemo } from 'react';
import getArg from '../args';

function fetchIpAddress(done) {
  if (getArg('serverDirect') || typeof window === 'undefined') {
    done('127.0.0.1');
  }
  if (window.userIpAddress) { // eslint-disable-line
    done(window.userIpAddress); // eslint-disable-line
  }
  // eslint-disable-next-line no-undef
  fetch('https://jsonip.com', { mode: 'cors' }).then(resp => resp.json()).then((ip) => {
    window.userIpAddress = ip.ip; // eslint-disable-line
    done(window.userIpAddress); // eslint-disable-line
  });
}

export default ({ ips = [], children }) => {
  const actualIps = useMemo(() => {
    if (Array.isArray(ips)) {
      return ips;
    }
    return [ips];
  }, ips);
  const [currentIp, setCurrentIp] = useState(null);
  useEffect(() => {
    fetchIpAddress((ip) => {
      if (currentIp !== ip) {
        setCurrentIp(ip);
      }
    });
  });
  if (actualIps.includes(currentIp)) {
    return children;
  }
  return null;
};
